const t = {
  name: "Ratio",
  dimensions: { width: 40, height: 25 },
  content: `
    <g clip-path="url(#clip0_12_5379)">
    <path d="M38.0032 0.00292969H2.00317C0.903174 0.00292969 0.00317383 0.90293 0.00317383 2.00293V22.0029C0.00317383 23.1029 0.903174 24.0029 2.00317 24.0029H38.0032C39.1032 24.0029 40.0032 23.1029 40.0032 22.0029V2.00293C40.0032 0.90293 39.1032 0.00292969 38.0032 0.00292969ZM2.00317 21.0029V2.00293H37.0032C37.5532 2.00293 38.0032 2.45293 38.0032 3.00293V22.0029H3.00317C2.45317 22.0029 2.00317 21.5529 2.00317 21.0029Z" fill="currentColor"/>
    <path d="M9.00317 4.00293H5.00317C4.45317 4.00293 4.00317 4.45293 4.00317 5.00293V9.00293C4.00317 9.55293 4.45317 10.0029 5.00317 10.0029C5.55317 10.0029 6.00317 9.55293 6.00317 9.00293V6.00293H9.00317C9.55317 6.00293 10.0032 5.55293 10.0032 5.00293C10.0032 4.45293 9.55317 4.00293 9.00317 4.00293Z" fill="currentColor"/>
    <path d="M35.0032 14.0029C34.4532 14.0029 34.0032 14.4529 34.0032 15.0029V18.0029H31.0032C30.4532 18.0029 30.0032 18.4529 30.0032 19.0029C30.0032 19.5529 30.4532 20.0029 31.0032 20.0029H35.0032C35.5532 20.0029 36.0032 19.5529 36.0032 19.0029V15.0029C36.0032 14.4529 35.5532 14.0029 35.0032 14.0029Z" fill="currentColor"/>
    </g>
    <defs>
    <clipPath id="clip0_12_5379">
    <rect width="40" height="24" fill="currentColor" transform="translate(0.00317383 0.00292969)"/>
    </clipPath>
    </defs>
  `
};
export {
  t as Ratio
};
